module.exports = __webpack_public_path__ + "static/ogp-1913af7e53dd07a41ade6337b1f0254c.jpg";